{
  "$schema": "http://json-schema.org/draft-06/schema#",
  "type": "object",
  "properties": {
    "CogAtlasID": { "$ref": "common_definitions.json#/definitions/CogAtlasID" },
    "CogPOID": { "$ref": "common_definitions.json#/definitions/CogPOID" },
    "AcquisitionDuration": {
      "type": "number",
      "exclusiveMinimum": 0
    },
    "EchoTime": {
      "type": "number",
      "exclusiveMinimum": 0
    },
    "EffectiveEchoSpacing": {
      "type": "number",
      "exclusiveMinimum": 0
    },
    "PhaseEncodingDirection": {
      "type": "string",
      "enum": ["i", "j", "k", "i-", "j-", "k-"]
    },
    "RepetitionTime": {
      "type": "number",
      "exclusiveMinimum": 0
    },
    "SliceEncodingDirection": {
      "type": "string",
      "enum": ["i", "j", "k", "i-", "j-", "k-"]
    },
    "SliceTiming": {
      "type": "array",
      "items": {
        "type": "number",
        "minimum": 0
      }
    },
    "TaskName": {
      "type": "string"
    },
    "VolumeTiming": {
      "type": "array",
      "items": {
        "type": "number",
        "minimum": 0
      }
    },
    "PartialFourier": {
      "type": "number"
    }
  }
}
